import {
  CButtonClassname,
  EButtonColor,
  ESectionAlign,
  ESectionColor,
  Section,
  SectionSubtitle,
  SectionTitle,
} from '@web_opxp/components';
import { SentryService, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import { HistoryService } from 'web_core_library';
import * as Actions from '../firebaseActions';

export interface IOwnProps {
  message?: string;
}

export interface IProps extends IOwnProps {
  onNotAuthorizedEvent: () => void;
}

export const NotAuthorizedPage: React.FC<IProps> = ({
  onNotAuthorizedEvent,
  message = 'common.common:Errors.UnauthorizedOrUnverified',
}) => {
  const { language, t } = useTranslation();

  const { state } = useLocation();
  let backUrlPath = '/';
  if (!!state && state.backUrl) {
    backUrlPath = state.backUrl;
  }
  React.useEffect(() => {
    onNotAuthorizedEvent();
  }, [onNotAuthorizedEvent]);

  React.useEffect(() => {
    SentryService.captureMessage('NotAuthorizedPage opened');
  }, []);

  if (!language) {
    return null;
  }

  const buttonLink = HistoryService.getSsoRedirectUrl(language, backUrlPath);
  return (
    <Section color={ESectionColor.orange} align={ESectionAlign.center}>
      <SectionTitle>{t('common.common:Errors.Titles.Unauthorized')}</SectionTitle>
      <SectionSubtitle>{t(message)}</SectionSubtitle>
      <a className={`${CButtonClassname} ${EButtonColor.white}`} href={buttonLink}>
        {t('common.common:LogIn')}
      </a>
    </Section>
  );
};

export const mapDispatchToProps = {
  onNotAuthorizedEvent: Actions.firebase401EventAction,
};

export default connect(null, mapDispatchToProps)(NotAuthorizedPage);
